import {
  createOwnershipRequest,
  deleteOwnershipRequest,
  updateContactRequest,
  updateOwnership
} from '../../../helpers/prospect_api';
import {
  ADD_CALL_CONSOLE_OWNERSHIP,
  DELETE_CALL_CONSOLE_OWNERSHIP,
  SET_CALL_CONSOLE_OWNER_CONTACT_METHOD_SCORE,
  SET_CALL_CONSOLE_VERIFIED_OWNER,
  UPDATE_CALL_CONSOLE_CONTACT,
  UPDATE_CALL_CONSOLE_DATA
} from './call_console';
import {
  DELETE_OFF_MARKET_PROPERTY_OWNERSHIP,
  SET_OFF_MARKET_PROPERTY_OWNER_CONTACT_METHOD_SCORE,
  SET_OFF_MARKET_PROPERTY_VERIFIED_OWNER,
  UPDATE_OFF_MARKET_PROPERTY,
  UPDATE_OFF_MARKET_PROPERTY_CONTACT
} from './off_market_property';
import { loadLlcData } from '../../../helpers/local_storage';

export const SET_OWNERS = 'SET_OWNERS';

export function setOwners(results) {
  return (dispatch, getState) => {
    const { offMarketProperty, callConsoleData } = getState();
    const insightsPropertyId = offMarketProperty.propertyId || callConsoleData.insightsProperty.propertyId;
    if (insightsPropertyId !== results.insightsPropertyId) {
      return;
    }

    if (offMarketProperty.propertyId) {
      const localOcCompany = loadLlcData(offMarketProperty.propertyId);
      const ocCompany = localOcCompany ? localOcCompany : results['connect/ocCompany'];
      dispatch({
        type: UPDATE_OFF_MARKET_PROPERTY,
        payload: {
          owners: results['connect/ownerships'],
          aiRelatedCompanies: results['connect/aiRelatedCompanies'],
          ocCompany: ocCompany
        }
      });
    } else if (callConsoleData.insightsProperty) {
      const localOcCompany = loadLlcData(callConsoleData.insightsProperty.propertyId);
      const ocCompany = localOcCompany ? localOcCompany : results['connect/ocCompany'];
      dispatch({
        type: UPDATE_CALL_CONSOLE_DATA,
        payload: {
          owners: results['connect/ownerships'],
          aiRelatedCompanies: results['connect/aiRelatedCompanies'],
          ocCompany: ocCompany
        }
      });
    }
  };
}

export function setVerifiedOwner(ownerId, verified) {
  return (dispatch, getState) => {
    const { offMarketProperty, callConsoleData } = getState();
    if (offMarketProperty.propertyId) {
      return updateOwnership(offMarketProperty.propertyId, ownerId, { verified }).then(() => {
        dispatch({
          type: SET_OFF_MARKET_PROPERTY_VERIFIED_OWNER,
          payload: { ownerId, verified }
        });
      });
    } else {
      return updateOwnership(callConsoleData.insightsProperty.propertyId, ownerId, { verified }).then(() => {
        dispatch({
          type: SET_CALL_CONSOLE_VERIFIED_OWNER,
          payload: { ownerId, verified }
        });
      });
    }

  };
}

export function setOwnerContactMethodScore(
  owner,
  contactMethodKey,
  contactMethodId,
  newScore
) {
  return (dispatch, getState) => {
    const { offMarketProperty, callConsoleData } = getState();
    return updateOwnership(
      offMarketProperty.propertyId ? offMarketProperty.propertyId : callConsoleData.insightsProperty.propertyId,
      owner.id,
      {
        contactAttributes: {
          id: owner.contact.id,
          [`${contactMethodKey}Attributes`]: [{ id: contactMethodId, connectRankScore: newScore }]
        }
      }
    ).then(() => {
      if (offMarketProperty.propertyId) {
        dispatch({
          type: SET_OFF_MARKET_PROPERTY_OWNER_CONTACT_METHOD_SCORE,
          payload: { ownerId: owner.id, contactMethodKey, contactMethodId, newScore }
        });
      } else {
        dispatch({
          type: SET_CALL_CONSOLE_OWNER_CONTACT_METHOD_SCORE,
          payload: { ownerId: owner.id, contactMethodKey, contactMethodId, newScore }
        });
      }

    });
  };
}

export function deleteOwnership(ownerId) {
  if (confirm('Delete this contact?')) {
    return (dispatch, getState) => {
      const { offMarketProperty, callConsoleData } = getState();
      return deleteOwnershipRequest(
        offMarketProperty.propertyId ? offMarketProperty.propertyId : callConsoleData.insightsProperty.propertyId,
        ownerId
      ).then(() => {
        if (offMarketProperty.propertyId) {
          dispatch({
            type: DELETE_OFF_MARKET_PROPERTY_OWNERSHIP,
            payload: { ownerId }
          });
        } else {
          dispatch({
            type: DELETE_CALL_CONSOLE_OWNERSHIP,
            payload: { ownerId }
          });
        }
      });
    };
  }
}

export function createOwnership(contactId) {
  return (dispatch, getState) => {
    const { callConsoleData } = getState();
    if (callConsoleData.insightsProperty.propertyId) {
      return createOwnershipRequest(callConsoleData.insightsProperty.propertyId, contactId).then((result) => {
        dispatch({
          type: ADD_CALL_CONSOLE_OWNERSHIP,
          payload: result['connect/ownership']
        });
      });
    }
  };
}

export function updateContact(contactId, params) {
  return (dispatch, getState) => {
    const { offMarketProperty } = getState();
    return updateContactRequest(contactId, params).then((data) => {
      if (offMarketProperty.propertyId) {
        dispatch({
          type: UPDATE_OFF_MARKET_PROPERTY_CONTACT,
          payload: data
        });
      } else {
        dispatch({
          type: UPDATE_CALL_CONSOLE_CONTACT,
          payload: data
        });
      }
    });
  };
}
